import { integer, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

/**
 * Stores the mapping between old DB integer PKs and new DB UUIDs for every
 * migrated entity. Written at the end of each per-org migration run.
 *
 * No RLS — this is operational/migration data, not product data. The migration
 * script already uses a privileged DB role that bypasses row-level security.
 */
export const migrationIdMaps = pgTable(
  'migration_id_maps',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    /** Integer org ID from the old DB — ties the row to a specific migration run. */
    oldOrgId: integer('old_org_id').notNull(),
    /** Table name in the new DB (e.g. 'candidates', 'jobs'). */
    tableName: text('table_name').notNull(),
    /** Integer primary key from the old DB. */
    oldId: integer('old_id').notNull(),
    /** UUID primary key in the new DB. */
    newId: uuid('new_id').notNull(),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow()
  },
  (t) => [unique('migration_id_maps_lookup').on(t.oldOrgId, t.tableName, t.oldId)]
);
